import { createAsyncThunk } from "@reduxjs/toolkit";
import { addCms, deleteCms, getCms, updateCms } from "store/services/cms";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get All Cms
export const GetAllCmsAction = createAsyncThunk(
  "cms/getAllCms",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getCms(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

//Update Cms
export const UpdateCmsAction = createAsyncThunk(
  "cms/updateCms",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onError, onSuccess, ...rest } = payload;
      const res = await updateCms(rest);
      if (res.status === 1) {
        dispatch(closeAdminModal());
        if (onSuccess) onSuccess();
        return fulfillWithValue(res);
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

//add Cms
export const AddCmsAction = createAsyncThunk(
  "cms/addCms",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await addCms(payload);
      if (res.status === 1) {
        dispatch(closeAdminModal());

        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

//delete Cms
export const DeleteCmsAction = createAsyncThunk(
  "cms/deleteCms",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await deleteCms(payload);
      if (res.status === 1) {
        return fulfillWithValue(payload);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);
